import { Component } from '@angular/core';

@Component({
	selector: 'pm-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css', '../../app.component.css'],
})
export class FooterComponent {
	fullImagePath: string;
	constructor() {
		this.fullImagePath = '/assets/images/sjcoe.png';
	}
 }
